//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
import HiHeader from "../../components/header/Index.vue";
import HiButton from "../../components/button/Index.vue";
import InstagramUserItem from "../../components/plan/instagram_user_item/Index.vue";
import { mapGetters } from "vuex";
import { CURRENT_USER_INFO_SIMPLE } from "../../store/mutation-types";
import { showErrorMsg } from "../../utils/error";
import HiCell from "../../components/cell/Index.vue";

export default {
  name: "AddInstagramAccountPage",
  components: { HiHeader, HiButton, InstagramUserItem, HiCell },
  data() {
    return {
      selectIds: [],
    };
  },
  methods: {
    /**
     * 单条记录点击事件
     */
    async itemClick(item) {
      if (item.type === "unselect") {
        await this.$alert.show({
          cancelText: "", // 不知道什么鬼。。总是被自动设置成cancel。。
          text: "You can only add unlimited schedules account.",
          yesText: "Ok",
        });
        return;
      }
      // 查看以选中项中是否包含点击项
      const index = this.selectIds.findIndex((id) => {
        return item.publisherId === id;
      });
      // 如果不存在，则添加当前点击项到数组中
      if (index === -1) {
        this.selectIds.push(item.publisherId);
      } else {
        // 否则删除该项
        this.selectIds.splice(index, 1);
      }
    },
    /**
     * select按钮点击事件
     */
    async saveSelectClick() {
      try {
        this.$loading.show();
        await this.teamMemberDetail.mulModifyPublisher({ ids: this.selectIds });
        this.$router.go(-1);
        this.$toast.show({ message: this.$t("common.success") });
      } catch (e) {
        showErrorMsg(e);
      } finally {
        this.$loading.hide();
      }
    },
    /**
     * add Instagram 点击事件
     */
    addInstagramClick() {
      // this.$router.push({name: 'LoginInstagramPage'})
    },
  },
  computed: {
    ...mapGetters({
      user: CURRENT_USER_INFO_SIMPLE,
    }),
    /**
     * 计算当前所选中的member
     */
    teamMemberDetail() {
      return this.user.teamMemberList.find(
        (t) => Number(t.id) === Number(this.$route.params.id)
      );
    },
    /**
     * 计算列表
     * @returns {Array}
     */
    list() {
      // 根据类型进行分组(过滤掉member 且有密码)
      // const list = this.user.linkedInstagramList
      //   .filter(l => !l.isMember && l.status === 1)
      //   .map(l => {
      //     l.select = this.selectIds.find(selectId => selectId === l.publisherId) !== undefined
      //     return l
      //   })
      // 根据类型进行分组
      let types = [];
      const limitedPublishers = this.user.linkedInstagramList.filter(
        (l) => !l.isUnlimited && !l.isMember && l.status === 1
      );
      const unlimitedPublishers = this.user.linkedInstagramList.filter(
        (l) => l.isUnlimited && !l.isMember && l.status === 1
      );
      if (unlimitedPublishers.length > 0) {
        types.push({
          itemType: "remove",
          title: this.$t("addUnlimitedAccountPage.normalUnlimitedUserType"),
          items: unlimitedPublishers.map((p) => {
            return { ...p, type: "select" };
          }),
        });
      }
      if (limitedPublishers.length > 0) {
        types.push({
          itemType: "remove",
          title: this.$t("addUnlimitedAccountPage.freeUserType"),
          items: limitedPublishers.map((p) => {
            return { ...p, type: "unselect" };
          }),
        });
      }
      types.forEach((t) => {
        t.items.forEach((l) => {
          l.select =
            this.selectIds.find((selectId) => selectId === l.publisherId) !==
            undefined;
        });
      });
      return types;
    },
  },
  activated() {
    // 选中原来已经激活项
    this.selectIds = this.teamMemberDetail.publishers.map((p) => p.publisherId);
  },
};



// WEBPACK FOOTER //
// ./src/pages/team_member/AddInstagramAccount.vue